import { getScript } from './utils/utils';
import { vimeoAllowed, onVimeoAllowed } from './utils/vimeo-consent';

export default function () {

    const players = document.querySelectorAll('.video-player-wrapper');

    if (players.length === 0)
        return;

    let pending = null;

    players.forEach(function (item) {
        item.addEventListener('click', function () {
            if (vimeoAllowed()) {
                play(item);
                return;
            }

            // film rusza po zgodzie z dowolnego CMP; Consent Mode nie ma API do otwarcia baneru, stąd opcjonalny Cookiebot
            pending = item;
            window.Cookiebot?.renew();
        });
    });

    if (vimeoAllowed())
        loadPlayerApi();

    onVimeoAllowed(function () {
        loadPlayerApi();
        if (pending) play(pending);
        pending = null;
    });
}

let playerApi = null;

function loadPlayerApi() {
    if (!playerApi)
        playerApi = new Promise(resolve => window.Vimeo ? resolve() : getScript('https://player.vimeo.com/api/player.js', resolve));

    return playerApi;
}

function play(item) {
    loadPlayerApi().then(function () {
        const url = item.getAttribute('data-url');

        var player = new Vimeo.Player(item.id, {
            url: url,
            width: 960
        });

        player.on("play", function (data) {

            if (typeof exponea !== 'undefined') {
                exponea.track('video_play', { video_name: player.element.title })

            }
        });

        player.play();
    });
}
